import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { XeroObjectDataset } from 'app/model/dataset/xero.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { XeroLinkedService } from 'app/model/linkedservice/xero.linkedservice';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { IModel } from 'app/model/base/annotation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(XeroObjectDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                table: '*' ,
                tableName: '*' // backward compatibility
            }
        }
    }
})
export class XeroObjectDatasetAdapter extends TabularTypeDatasetAdapter<XeroObjectDataset, Model.DatasetResource> {
    protected model(): IModel {
            return XeroObjectDataset.MODEL;
        }
    protected async _toResource(dataset: XeroObjectDataset): Promise<Model.DatasetResource> {

        const linkedService = dataset?.linkedService as XeroLinkedService;
        if (linkedService?.version === 'v2') {
            return await this._toResourceInternal(dataset, this.model().name, 'table');
        }
        return await this._toResourceInternal(dataset, this.model().name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: XeroObjectDataset): Promise<XeroObjectDataset> {
        if (!dataset) {
            dataset = this.model().create<XeroObjectDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource?.properties as Model.XeroObjectDataset;
        if (model?.typeProperties?.table) {
            ValueAdapter.toModel(dataset, XeroObjectDataset.TABLE_NAME, model.typeProperties.table);
        }
        else {
            ValueAdapter.toModel(dataset, XeroObjectDataset.TABLE_NAME, model?.typeProperties?.tableName);
        }
        return dataset;
    }
}
